import React from 'react';

const severityTone = {
  critical: 'text-rose-300 bg-rose-500/10',
  high: 'text-orange-300 bg-orange-500/10',
  medium: 'text-amber-300 bg-amber-500/10',
  low: 'text-sky-300 bg-sky-500/10',
};

const AIAnomalyTable = ({ rows = [], showTenant = false, variant = 'dark', onRowClick }) => {
  const isLight = variant === 'light';
  const buildRowHandlers = (row) => {
    if (typeof onRowClick !== 'function') {
      return {};
    }
    return {
      role: 'button',
      tabIndex: 0,
      onClick: () => onRowClick(row),
      onKeyDown: (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onRowClick(row);
        }
      },
    };
  };
  return (
    <div className={isLight ? 'overflow-hidden rounded-2xl border border-border bg-card' : 'overflow-hidden rounded-2xl border border-slate-700/80 bg-slate-950/95'}>
      <div className={`grid grid-cols-[1.5fr_0.8fr_0.8fr_0.8fr] gap-3 px-4 py-3 text-[11px] uppercase tracking-[0.18em] ${isLight ? 'border-b border-border text-muted-foreground' : 'border-b border-slate-700/80 text-slate-300'}`}>
        <span>{showTenant ? 'Tenant / Signal' : 'Signal'}</span>
        <span>Severity</span>
        <span>Risk</span>
        <span>Status</span>
      </div>
      <div className={isLight ? 'divide-y divide-border' : 'divide-y divide-slate-800/80'}>
        {rows.map((row) => (
          <div
            key={row.id}
            className={`grid grid-cols-[1.5fr_0.8fr_0.8fr_0.8fr] gap-3 px-4 py-4 text-sm ${isLight ? 'text-foreground' : 'text-slate-100'} ${typeof onRowClick === 'function' ? 'cursor-pointer transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary/40' : ''}`}
            {...buildRowHandlers(row)}
          >
            <div>
              <p className={`font-medium ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{showTenant ? row.tenant_name : row.title}</p>
              <p className={`mt-1 text-xs ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>{showTenant ? row.title : row.description}</p>
            </div>
            <div>
              <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium capitalize ${severityTone[row.severity] || severityTone.medium}`}>
                {row.severity}
              </span>
            </div>
            <div className={`font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{Number(row.risk_score || 0).toFixed(1)}</div>
            <div className={`capitalize ${isLight ? 'text-foreground' : 'text-slate-200'}`}>{String(row.status || '').replace('_', ' ')}</div>
          </div>
        ))}
        {rows.length === 0 && (
          <div className={`px-4 py-8 text-center text-sm ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>No anomalies detected.</div>
        )}
      </div>
    </div>
  );
};

export default AIAnomalyTable;
